/**
 * This initializer registers format.js for ember intl formatter to use.
 */
import Formats from '@banking/ui/formats';

export function initialize(application) {
  application.register('formats:main', Formats);
}

export default {
  initialize,
};
